import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { queryKeys as clientSearchQKs } from '../../ClientSearch/api/queryKeys';
import { getApplicationVariables } from '../../AdviserArea/AdviserAreaActions';

export const DELETE_CLIENT_ENDPOINT = '/Adviser/Adviser/DeleteClient';
export const REMOVE_CLIENT_ENDPOINT = '/Adviser/Adviser/RemoveClient';

interface DeleteClientParams {
  clientId: string;
  canDeleteClient: boolean;
}

const deleteClient = ({ clientId, canDeleteClient }: DeleteClientParams) => {
  return authFetch(canDeleteClient ? DELETE_CLIENT_ENDPOINT : REMOVE_CLIENT_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions({ clientId }),
  });
};

export const useDeleteClientMutation = () => {
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  return useMutation(deleteClient, {
    onSuccess: async () => {
      ADV.util.clearDashboardCache();

      await dispatch(getApplicationVariables({ showSpinner: false }));

      queryClient.invalidateQueries(clientSearchQKs.clientList());

      ADV.util.Router.go2('ClientSearch');
    },
  });
};
